import { render } from "./BomValidationResultsVersionToggle.vue?vue&type=template&id=7072250c&scoped=true"
import script from "./BomValidationResultsVersionToggle.vue?vue&type=script&lang=js"
export * from "./BomValidationResultsVersionToggle.vue?vue&type=script&lang=js"

import "./BomValidationResultsVersionToggle.vue?vue&type=style&index=0&id=7072250c&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7072250c"]])

export default __exports__